import first from 'lodash/first.js';
import get from 'lodash/get.js';
import orderBy from 'lodash/orderBy.js';
import uniqBy from 'lodash/uniqBy.js';

import Model from '@/models/Model.js';

export default class Video extends Model {
    static entity = 'videos';

    static modelName = 'Video';

    static fields() {
        return {
            id: this.attr(null),
            title: this.attr(null),
            description: this.attr(null),
            reference_id: this.attr(null),
            aws_job_id: this.attr(null),
            hls_url: this.attr(null),
            resolved_hls_url: this.attr(null),
            hls_cookies: this.attr([]),
            thumbnail_url: this.attr(null),
            resolved_thumbnail_url: this.attr(null),
            thumbnail_signed_url: this.attr(null),
            caption: this.attr(null),
            progress: this.attr(null),
            input_size: this.attr(null),
            output_size: this.attr(null),
            duration_seconds: this.attr(null),
            uploaded_at: this.attr(null),
            processed_at: this.attr(null),
            collection: this.attr(null),
            is_stuck: this.boolean(false),

            ...super.fields(),

            video_activities: this.hasMany('video_activities', 'video_id'),
            video_activity_templates: this.hasMany('video_activity_templates', 'video_id'),
            tags: this.morphToMany('tags', 'taggables', 'tag_id', 'taggable_id', 'taggable_type'),
            groups: this.belongsToMany('groups', 'video_group', 'video_id', 'group_id'),
            course_codes: this.morphToMany(
                'course-codes',
                'course_codeables',
                'course_code_id',
                'course_codeable_id',
                'course_codeable_type'
            ),
            statuses: this.morphMany('statuses', 'model_id', 'model_type_entity'),
        };
    }

    /**
     * @deprecated This method should not be required and resolves an issue of duplicate tags.
     */
    uniqueTags() {
        return uniqBy(this.tags, 'id');
    }

    get is_complete() {
        // Videos are complete when processed and have either reference_id or resolved_hls_url
        return this.processed_at !== null && (this.reference_id !== null || this.resolved_hls_url !== null);
    }

    get is_progressing() {
        return this.processed_at === null;
    }

    get is_failed() {
        return get(this.latest_status, 'name') === 'error';
    }

    get latest_status() {
        return first(orderBy(this.statuses, 'id', 'desc'));
    }
}
